/**
 * 获取当前设备的网络信息
 * @returns
 */
export function getNetworkInfo() {
  const connection = (navigator as any).connection
  return JSON.stringify(
    connection
      ? {
          onLine: navigator.onLine,
          downlink: connection.downlink,
          effectiveType: connection.effectiveType,
          rtt: connection.rtt,
          saveData: connection.saveData
        }
      : {
          onLine: navigator.onLine
        }
  )
}
